
import request from "@/utils/request";

export function getAllFruitTypeOptions() {
    return request({
        url: "/api/services/app/FruitType/GetAllForDropdown",
        method: "GET"
    });
}

export function fruitTypeAllFromCrossType(params) {
    return request({
        url: "/api/services/app/FruitType/GetAllFruitTypeFromCrossType",
        method: "GET",
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/fruit_type.js